import {computed, observable} from 'mobx';
import {getIn} from '../utils';
import {SERVICE_TYPE} from '../model/const';

class Service {
  @observable content;

  constructor(content) {
    this.content = content; 
  }

  @computed get id() {
    if(this.content.IsGeneral) {
      return this.content.Id;
    } else {
      return this.content.refRentalServiceId;
    }
    //return this.content.Id || this.content.refRentalServiceId;
  }

  @computed get ids() {
    return [this.content.Id, this.content.refRentalServiceId];
  }
 
  @computed get name() {
    return getIn(this.content, ['Name']);
  }

  @computed get description() {
    return this.content.Description;
  }

  @computed get price() {
    return this.content.FixedPrice || this.content.OfferPrice; // || this.content.PercentagePrice;
  }


  @computed get fixedPrice() {
    return this.content.FixedPrice;
  }

  @computed get percentagePrice() {
    return this.content.PercentagePrice
  }

  @computed get offerPrice() {
    return this.content.OfferPrice
  }

  @computed get typeId() {
    return this.content.refRentalServiceTypeId;
  }

  @computed get typeName() {
    return this.content.RentalServiceType_Name;
  }

  @computed get canBeSelected() {
    return this.typeId === SERVICE_TYPE.WAHLBAR;
  }

}

export class Services {
  constructor(rentalObject, bestOffers, rentalTransaction, businessUnit) {
    this.rentalObject = rentalObject;
    this.bestOffers = bestOffers;
    this.rentalTransaction = rentalTransaction;
    this.businessUnit = businessUnit;
  }

  @computed get avail() {
    // TODO: Move enveloping by Service wrapper to businessUnit and rentalObject modules
    const generalServices = this.businessUnit.services.map(o => new Service(o));
    const objectServices = this.rentalObject.services.map(o => new Service(o));
    let mergedServices = [...generalServices];
    for(let objectService of objectServices) {
      if(!mergedServices.find(o => o.id === objectService.id)) {
        mergedServices.push(objectService);
      }
    }
    return mergedServices;
  }

  @computed get joinedListing() {
    const availableServices = this.avail;
    const transactionServices = this.rentalTransaction.services;
    const joinedListing = [];
    for(let availService of availableServices) {
      let item = {
        available: availService,
        inTransaction: {},
      }
      for(let transactionService of transactionServices) {
        if(availService.id === transactionService.idRentalService) {
          item.inTransaction = transactionService;
        }
      }
      joinedListing.push(item);
    }
    return joinedListing;
  }
}


// WEBPACK FOOTER //
// ./src/aggregate/Services.js